import { BreadcrumbItem } from '@components/atoms/ui-kit/breadcrumbs.tsx';
import { fetchFolder } from '@utils/api/folders/use-get-folder';
import { PATHS } from '../../router/paths.ts';

export const buildFolderBreadcrumbTrail = async (folder: {
  parent_id: number | null;
}): Promise<BreadcrumbItem[]> => {
  const trail: BreadcrumbItem[] = [];
  let current = folder;

  while (current.parent_id) {
    try {
      const { result } = await fetchFolder(current.parent_id.toString());
      trail.unshift({
        id: result.id,
        name: result.name,
        path: PATHS(result.id.toString()).FOLDER_CONTENT
      });
      current = result;
    } catch {
      break;
    }
  }

  return trail;
};
